var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({key:_vm.src,ref:"container",tag:"component",on:{"click":function($event){_vm.loadFail && _vm.loadImg()}}},'component',_vm.bindProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }